import _jsx from '@babel/runtime/helpers/jsx';
import require$$0, { useState as useState$1, useEffect as useEffect$1 } from 'react';
import { AndesProvider } from '@andes/context';
import 'prop-types';
import 'classnames';
import CarouselSnapped, { CarouselSnappedSlide } from '@andes/carousel-snapped';
import TrendsEntry from '@seo-frontend-components/trends-entry';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
var _Service;
/**
 * Service interface
 */
class Service {}
/**
 * Expose Service
 */
_Service = Service;
_defineProperty(Service, "replaceBlanksWithDash", str => _Service.replaceBlanks(str, '-'));
_defineProperty(Service, "replaceBlanks", (str, value) => str.replace(/ /g, value));
_defineProperty(Service, "capitalizeFirstLetter", str => str[0].toUpperCase() + str.slice(1));
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
const {
  useState,
  useEffect
} = require$$0;
function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState({
    width: undefined,
    height: undefined
  });
  useEffect(() => {
    const resizeObserver = new ResizeObserver(entries => {
      entries.forEach(entry => {
        const {
          width,
          height
        } = entry.contentRect;
        setWindowDimensions({
          width,
          height
        });
      });
    });
    resizeObserver.observe(document.documentElement);
    return () => {
      resizeObserver.disconnect();
    };
  }, []);
  return windowDimensions;
}
var useWindowDimensions_1 = useWindowDimensions;
var useWindowDimensions$1 = /*@__PURE__*/getDefaultExportFromCjs(useWindowDimensions_1);

/**
 * TrendsCarousel Component
 */
function TrendsCarousel(props) {
  const namespace = 'seo-ui-trends-carousel';
  const {
    trends_categories,
    deviceType,
    jsDisabled,
    supportWebP,
    trendsToViewMinDefault,
    trendsToViewDefault,
    minWidthToShowAllEntries,
    thumbnailSize,
    locale,
    animated,
    paginationPosition,
    paginationMode
  } = props;
  const containerClass = 'container-menu';
  const {
    width
  } = useWindowDimensions$1();
  const [trendsToView, setTrendsToView] = useState$1(trendsToViewDefault);
  const [showCarousel, setShowCarousel] = useState$1(jsDisabled);
  useEffect$1(() => {
    if (width === undefined) {
      return;
    }
    if (width > minWidthToShowAllEntries) {
      setTrendsToView(trendsToViewDefault);
    } else {
      setTrendsToView(trendsToViewMinDefault);
    }
    setShowCarousel(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width, trendsToViewDefault, trendsToViewMinDefault, minWidthToShowAllEntries]);
  const titleNode = /*#__PURE__*/_jsx("h2", {}, void 0, trends_categories.title);
  const titleKey = Service.replaceBlanksWithDash(trends_categories.title);
  if (!showCarousel) {
    const loadingClass = `${namespace}-loading`;
    return /*#__PURE__*/_jsx("section", {
      className: loadingClass
    });
  }
  return /*#__PURE__*/_jsx(AndesProvider, {
    locale: locale
  }, void 0, /*#__PURE__*/_jsx("section", {
    className: `${namespace}`
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: `${containerClass} container`
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: `${namespace}-wrapper`
  }, void 0, /*#__PURE__*/_jsx(CarouselSnapped, {
    pagination: {
      mode: paginationMode,
      position: paginationPosition
    },
    title: titleNode,
    lazyload: true,
    slidesPerView: trendsToView,
    spacing: 16,
    strictBoundaries: false
  }, void 0, trends_categories.trends.map((trend, index) => /*#__PURE__*/_jsx(CarouselSnappedSlide, {}, `${titleKey}-${index}-slide`, /*#__PURE__*/_jsx("div", {
    className: "entry-column"
  }, void 0, /*#__PURE__*/_jsx(TrendsEntry, {
    trend: trend,
    deviceType: deviceType,
    insideCarousel: true,
    jsDisabled: jsDisabled,
    supportWebP: supportWebP,
    thumbnailSize: thumbnailSize
  })))))))));
}
TrendsCarousel.defaultProps = {
  trendsToViewMinDefault: 3,
  trendsToViewDefault: 4,
  minWidthToShowAllEntries: 1275,
  thumbnailSize: '48',
  animated: true,
  locale: 'es-AR',
  paginationPosition: 'top',
  paginationMode: 'light'
};

/**
 * Inject i18n context as props into TrendsCarousel.
 */
TrendsCarousel.displayName = 'TrendsCarousel';
export { TrendsCarousel as default };
